import { AppThunk } from 'src/store/store';
import { setPaymentCheckFailed, setPaymentSuccessInfo } from './paymentSlice';
import api from '../../../api';
import { FLOWS_ENUM } from '../../../common/enums';

// Thunks - these are asynchronous functions that interact with reducers in predictable ways
// All api interactions should be performed via a "thunk" so that api request state can
// be updated in the Redux store rather than at the component level

// Thunks - these are asynchronous functions that interact with reducers in predictable ways
// All api interactions should be performed via a "thunk" so that api request state can
// be updated in the Redux store rather than at the component level
type CompletionCallbackCallback = (param?: boolean) => void | undefined;

export type CompletionCallback<T = boolean> = (
  params?: T
) => CompletionCallbackCallback | void;
export interface PayNothingOutcome {
  success: boolean;
  paymentId: string;
  id: string;
  paymentConfirmation: string;
}

export const checkTaxPaymentAsync = (
  paymentID: string,
  completionCallback: CompletionCallbackCallback
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const data = await api.checkTaxPayment(getState(), paymentID);
      dispatch(setPaymentSuccessInfo(data));
    } catch (error) {
      dispatch(setPaymentCheckFailed(true));
    } finally {
      completionCallback();
    }
  };
};

export const checkPaymentAsync = (
  paymentID: string,
  flow: FLOWS_ENUM,
  completionCallback: CompletionCallbackCallback
): AppThunk<void, typeof api> => {
  return async (dispatch) => {
    if (flow === FLOWS_ENUM.PAY_TOT) {
      return dispatch(checkTaxPaymentAsync(paymentID, completionCallback));
    } else if (
      flow === FLOWS_ENUM.APPLY_LICENSE ||
      flow === FLOWS_ENUM.RENEW_LICENSE
    ) {
      return dispatch(
        checkApplicationPaymentAsync(paymentID, completionCallback)
      );
    } else {
      throw new Error(`Unsupported flow: ${flow}`);
    }
  };
};

export const checkApplicationPaymentAsync = (
  paymentID: string,
  completionCallback: CompletionCallbackCallback = () => undefined
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const data = await api.checkLicensePayment(getState(), paymentID);
      dispatch(setPaymentSuccessInfo(data));
    } catch (error) {
      dispatch(setPaymentCheckFailed(true));
    } finally {
      completionCallback();
    }
  };
};

export const payNothing = (
  emailAddress: string,
  onCompletionCallback: CompletionCallback<PayNothingOutcome>
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    const outcome: PayNothingOutcome = {
      success: false,
      id: '',
      paymentId: '',
      paymentConfirmation: '',
    };
    try {
      const { paymentId } = await api.payNothing(
        getState(),
        getState()?.payment.paymentID as string,
        emailAddress
      );
      if (paymentId) {
        const data = await api.checkLicensePayment(getState(), paymentId);
        const { id, paymentConfirmation } = data;
        dispatch(setPaymentSuccessInfo(data));
        if (id !== undefined && paymentConfirmation !== undefined) {
          outcome.success = true;
          outcome.paymentId = paymentId;
          outcome.id = id;
          outcome.paymentConfirmation = paymentConfirmation;
        }
      }
      onCompletionCallback(outcome);
    } catch (error) {
      onCompletionCallback(outcome);
    }
  };
};

export const payNothingTax = (
  emailAddress: string,
  onCompletionCallback: CompletionCallback<boolean>
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const { paymentID, signatoryName } = getState()?.payment;
      const { paymentId } = await api.payNothingGeneric(
        getState(),
        paymentID as string,
        signatoryName as string,
        emailAddress as string
      );
      if (paymentId) {
        dispatch(
          checkTaxPaymentAsync(
            paymentID as string,
            onCompletionCallback(true) as CompletionCallbackCallback
          )
        );
      } else {
        onCompletionCallback(false);
      }
    } catch (error) {
      onCompletionCallback(false);
    }
  };
};

export const payNothingRenewal = (
  emailAddress: string,
  onCompletionCallback: CompletionCallback
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    try {
      const { paymentID, signatoryName } = getState()?.payment;
      const { paymentId } = await api.payNothingGeneric(
        getState(),
        paymentID as string,
        signatoryName as string,
        emailAddress as string
      );
      if (paymentId) {
        dispatch(
          checkApplicationPaymentAsync(
            paymentID as string,
            onCompletionCallback(true) as CompletionCallbackCallback
          )
        );
      } else {
        onCompletionCallback(false);
      }
    } catch (error) {
      onCompletionCallback(false);
    }
  };
};

export const payCheck = (
  completionCallback: CompletionCallback = () => undefined
): AppThunk<void, typeof api> => {
  return async (dispatch, getState, api) => {
    const { paymentID, signatoryName } = getState()?.payment;
    const email = getState().auth.userDetails?.email;

    try {
      const data = await api.payByCheck(
        paymentID as string,
        signatoryName as string,
        email as string
      );
      dispatch(setPaymentSuccessInfo(data));
    } catch (error) {
      dispatch(setPaymentCheckFailed(true));
    } finally {
      completionCallback();
    }
  };
};
